// extracted by mini-css-extract-plugin
module.exports = {"NoData":"mCKwpYAZ3rwsBvzWmQFY"};